import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CurrencyComponent } from '@web/shared/ui';

@Component({
  selector: 'app-refunded-price',
  imports: [CurrencyComponent],
  templateUrl: './refunded-price.component.html',
  styleUrl: './refunded-price.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefundedPriceComponent {
  public readonly originalPrice = input.required<number>();
  public readonly refundedPrice = input.required<number>();
  public readonly currentPrice = input.required<number>();
}
